import { render, staticRenderFns } from "./wrapped.vue?vue&type=template&id=4a4b306b&scoped=true&"
import script from "./wrapped.vue?vue&type=script&lang=js&"
export * from "./wrapped.vue?vue&type=script&lang=js&"
import style0 from "./wrapped.vue?vue&type=style&index=0&id=4a4b306b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b306b",
  null
  
)

export default component.exports